/**
 * ZooRoyal listing Page.
 */

@use '../../zr-theme/zr-variables.scss' as *;
@use '../../zr-theme/zr-theme.scss';
@use '../../zr-theme/functions/fonts' as f;

$component: 'zr-listing-page';

:host {
    display: block;
    margin: 0 -15px;

    --vx-grid-template-columns: repeat(1, 1fr);

    & > h1{
        padding: 0 15px;
        margin: 16px auto;
        font-size: f.calc-em(26);
        text-align: center;
    }
}

.#{$component}__filter-sorting-container{
    border: 1px solid var(--neutral-neutral-300, #ECECEC);
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    hr{
        display: none;
    }

    & :last-child{
        border-left: 1px solid var(--neutral-neutral-300, #ECECEC);
    }
}

.#{$component}__selected-filter{
    display: none;
}

.#{$component}__header {
    padding: 0 16px;
}

.#{$component}__category-headline {
    padding: 0 15px;
    margin: 16px auto;
    font-size: f.calc-em(26);
    text-align: center;
}

.#{$component}__search-result-headline {
    text-align: center;

    &,
    &--no-result {
        font-size: f.calc-em(16);
        line-height: f.calc-em(24);
        font-weight: normal;
    }

    &--no-result {
        text-align: left;
    }
}

.#{$component}__search-term {
    font-family: 'Museo Sans Rounded', sans-serif;
    font-size: f.calc-em(20);
    line-height: 1em;
}

.#{$component}__sorting-container{
    border-left: 1px solid var(--neutral-neutral-300, #ECECEC);
}

@media only screen and (min-width: $tablet-screen) {
    :host {
        margin: 0;

        --vx-grid-template-columns: repeat(2, 1fr);

        & > h1{
            padding: 0;
            margin: 9px auto 40px;
            font-size: f.calc-em(36);
            text-align: left;
        }
    }

    .#{$component}__filter-sorting-container{
        border: 0;
        border-top: 1px solid var(--neutral-neutral-300, #ECECEC);
        display: grid;
        margin-bottom: 22px;
        grid-template-columns: 1fr 200px;

        hr{
            display: block;
            grid-column: 1/3;
            width: 100%;
            height: 1px;
            margin: 0;
            padding: 0;
            background-color: var(--neutral-neutral-300, #ECECEC);
            color: var(--neutral-neutral-300, #ECECEC);
            border: 0;
        }

        & :last-child{
            border-left: 0;
        }
    }

    .#{$component}__filter{
        grid-column: 1/3;
    }
    .#{$component}__selected-filter{
        display:block;
        margin-top: 13px;
    }

    .#{$component}__header {
        padding: 0;
    }

    .#{$component}__category-headline {
        padding: 0;
        margin: 9px auto 40px;
        font-size: f.calc-em(36);
        text-align: left;
    }

    .#{$component}__sorting-container{
        margin-top: 13px;
    }

    .#{$component}__search-result-headline {
        font-size: f.calc-em(20);
        line-height: f.calc-em(30);
        text-align: left;
    }

    .#{$component}__search-term {
        font-family: 'Museo Sans Rounded', sans-serif;
        font-size: f.calc-em(28);
    }
}

@media only screen and (min-width: $desktop-screen) {
    :host {
        --vx-grid-template-columns: repeat(4, 1fr);
    }
}
